import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import router from "@/router";

//Load our modules here
// -- A module is an individual JS file where we create and store data
//     -- Start with our general settings
import settings from "./modules/settings";

//    -- Now our API calls (the results of which we'll store)
import configs from "./modules/configs";
import user from "./modules/user";
import customer from "./modules/customer";
import faq from "./modules/faq";
import ordersHistory from "./modules/ordersHistory";
import payment from "./modules/payment";

//    -- Our order module
import order from "./modules/order";
import orderSearch from "./modules/orderSearch";

//    -- Our template module
import template from "./modules/template";
import templateSearch from "./modules/templateSearch";

//   -- Our standing order module
import standingOrders from "./modules/standingOrders";
import standingOrderSearch from "./modules/standingOrderSearch";

//    -- Our Delivery Addresses Module
import deliveryAddresses from "./modules/deliveryAddresses";

//    -- Our Snackbar modules
import snackbarStatic from "./modules/snackbarStatic";

//    -- Our Theme modules
import caterpointTheme from "./modules/themeCaterpoint";
import customTheme from "./modules/themeCustom";

//    -- Our Admin module
import admin from "./modules/admin";

//    -- New Modules
import postcodes from "./modules/deliveryPostcodes";
import orderDiscounts from "./modules/orderDiscounts";
import stockAlerts from "./modules/stockAlerts";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: "cpgo2",
  // storage: window.localStorage,
  modules: [
    "settings",
    "configs",
    "user",
    "customer",
    "faq",
    "order",
    "ordersHistory",
    // "orderSearch",
    "template",
    // "templateSearch",
    "payment",
    "snackbarStatic",
    "standingOrders",
    // "standingOrderSearch",
    "caterpointTheme",
    "customTheme",
  ],
});

export default new Vuex.Store({
  state: {
    snackbar: {},
  },
  mutations: {
    SET_SNACKBAR(state, snackbar) {
      state.snackbar = snackbar;
    },
  },
  actions: {
    setSnackbar({ commit,dispatch }, snackbar) {
      snackbar.showing = true;
      snackbar.timeout = snackbar.timeout || 3000;
      snackbar.color = snackbar.color || "success";
      snackbar.btnText = snackbar.btnText || "Close"
      snackbar.redirect = snackbar.redirect || null
      commit("SET_SNACKBAR", snackbar);
      setTimeout(() => {
       dispatch("autoResetSnackbar")
      }, snackbar.timeout);
    },
    autoResetSnackbar({commit}) {
      commit("SET_SNACKBAR",{})
    },
    resetSnackbarDefault({ commit,state }) {
      if(state.snackbar.redirect && state.snackbar.redirect != null) {
        router.push({name : state.snackbar.redirect})
      }
      commit("SET_SNACKBAR", {});
    },
    userSignoutAction({ dispatch }) {
      dispatch("orderSearch/resetSearchPage");
      dispatch("orderSearch/setAutoload", true);

      dispatch("templateSearch/clearTemplate");
      dispatch("standingOrderSearch/clearStandingSearch");

      dispatch("clearTrollys");
      dispatch("setSelectedTrolly", 0);

      dispatch("clearCustomer");
      dispatch("clearUser");
      dispatch("clearFAQ");
      dispatch("clearOrders");
      dispatch("clearStandingOrder");
      dispatch("clearAdmin");
      dispatch("clearAddresses");
    },
  },
  modules: {
    settings,
    configs,
    user,
    customer,
    faq,
    order,
    ordersHistory,
    orderSearch,
    template,
    templateSearch,
    payment,
    snackbarStatic,
    standingOrders,
    standingOrderSearch,
    caterpointTheme,
    customTheme,
    deliveryAddresses,
    admin,
    postcodes,
    orderDiscounts,
    stockAlerts,
  },
  plugins: [vuexLocal.plugin],
});
